import React from 'react';

import { useOfferType } from '../../utils/useOfferType';
import { FOfferType } from '../../../../JsonQuery';
import { useContext } from '../../utils/useContext';
import { addPikAdfoxBanner } from '../../../../../shared/serp/components/adfox';
import { BannerInFilter } from '../../components/advancedFilters/common/BannerInFilter';

export function PikBannerInFiltersContainer() {
  const {
    appContext: { makeRequest },
    currentLocation,
  } = useContext();
  const offerType = useOfferType();

  const locationId = React.useMemo(() => {
    if (currentLocation === 'moscow_mo') {
      return 1;
    }
    if (currentLocation === 'spb_lo') {
      return 2;
    }

    return currentLocation.parentId || currentLocation.id;
  }, [currentLocation]);

  if (offerType !== FOfferType.FlatNew) {
    return null;
  }

  return <BannerInFilter>{addPikAdfoxBanner(locationId, makeRequest)}</BannerInFilter>;
}
